import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormProgressInfo } from '@finxone-platform/shared/sys-config-types';
import { catchError, Observable } from 'rxjs';
import {
  FormSessionRequest,
  FormSessionResponse,
} from '../../utils/form-widget-action-utils/form-tracking.utils';
import { ConfigService } from '../config-service/config-service.service';

@Injectable({
  providedIn: 'root',
})
export class FormSessionService {
  public baseUrl = '';

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.configService.getApi('metadata_service').subscribe((response) => {
      this.baseUrl = response;
    });
  }

  public formInProgress(payload: FormSessionRequest): Observable<FormSessionResponse> {
    return this.http.post<FormSessionResponse>(`${this.baseUrl}/form-progress`, payload).pipe(
      catchError<any, Observable<any>>((_err, _caught) => {
        throw _err;
      }),
    );
  }

  public updateFormCompletionState(payload: FormSessionRequest): Observable<FormSessionResponse> {
    return this.http.post<FormSessionResponse>(`${this.baseUrl}/form-progress/complete`, payload).pipe(
      catchError<any, Observable<any>>((_err, _caught) => {
        throw _err;
      }),
    );
  }

  public getFormProgressData(fromSessionId: string): Observable<any> {
    return this.http.get<FormProgressInfo>(`${this.baseUrl}/form-progress/${fromSessionId}`);
  }
}
